import React from 'react';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import { MemberBanner } from '@parchment/ui-primitives';
import LandingPage from './LandingPage';
import AccountConfirmationPage from '../containers/AccountConfirmationContainer';
import "../style/ThirdPartyRegistration.less";

export default function App() {
    const memberBannerProps = {
        member: window.config.member,
        bannerText: '',
        imageBaseUrl: window.location.origin
    };

    const Banner = () => window.config.member.name && (<MemberBanner {...memberBannerProps} />);

    return (
        <Router history={browserHistory}>
            <Route path="/u/registration/:memberId">
                <Route path="institution">
                    <IndexRoute component={(rtProps) => <LandingPage banner={<Banner />} {...rtProps} />} />
                    <Route path="confirm(/:code)" component={(rtProps) => <AccountConfirmationPage {...rtProps} />} />
                    <Route path="tpo/login" component={(rtProps) => <LandingPage banner={<Banner />} {...rtProps} />} />
                </Route>
            </Route>
            <Route path="/u/registration/institution/confirm" component={(rtProps) => <AccountConfirmationPage {...rtProps} />} />
        </Router>
    );
}
